export default "__VITE_ASSET__b8bead05__"